// Working Hours Types

export interface WorkingHour {
  id: string;
  weekday: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  start_min: number;
  end_min: number;
  weekday_name: string;
  start_time: string;
  end_time: string;
}

export interface Schedule {
  id: string;
  name: string;
  is_default: boolean;
  starts_at: string | null;
  ends_at: string | null;
  priority: number;
  status: 'active' | 'upcoming' | 'past';
  total_weekly_hours: number;
  working_days: number[];
  working_hours: WorkingHour[];
}

export interface ScheduleException {
  id: string;
  date: string;
  end_date: string | null;
  is_closed: boolean;
  start_min: number | null;
  end_min: number | null;
  reason: string | null;
  recurring_yearly: boolean;
  formatted_date: string;
  formatted_time_range: string | null;
}

export interface HolidaySetting {
  id: string;
  region_code: string;
  enabled: boolean;
  region_name: string;
  available_regions: { code: string; name: string }[];
}

export interface Holiday {
  date: string;
  name: string;
  region_code: string;
  formatted_date: string;
}

export interface CreateScheduleRequest {
  name: string;
  is_default?: boolean;
  starts_at?: string;
  ends_at?: string;
  priority?: number;
  working_hours_attributes?: {
    weekday: number;
    start_min: number;
    end_min: number;
  }[];
}

export interface UpdateScheduleRequest {
  name?: string;
  starts_at?: string;
  ends_at?: string;
  priority?: number;
  working_hours_attributes?: {
    id?: string;
    weekday: number;
    start_min: number;
    end_min: number;
    _destroy?: boolean;
  }[];
}

export interface CreateExceptionRequest {
  date: string;
  end_date?: string;
  is_closed: boolean;
  start_min?: number;
  end_min?: number;
  reason?: string;
  recurring_yearly?: boolean;
}

export interface UpdateExceptionRequest {
  date?: string;
  end_date?: string;
  is_closed?: boolean;
  start_min?: number;
  end_min?: number;
  reason?: string;
  recurring_yearly?: boolean;
}

export interface UpdateHolidaySettingsRequest {
  region_code?: string;
  enabled?: boolean;
}

export const WEEKDAY_NAMES: Record<number, string> = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
};

export const WEEKDAY_SHORT_NAMES: Record<number, string> = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun',
};

// Helper functions
export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}

export function timeToMinutes(time: string): number {
  const [hours, mins] = time.split(':').map(Number);
  return hours * 60 + mins;
}

export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins}m`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
}
